import { Heading2 } from "@/ui2/atoms/Heading";
import { Spinner2 } from "@/ui2/atoms/Spinner";

export function IdentityDocumentPreviewLoader() {
  return (
    <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4">
      <Spinner2 className="tw:text-text-teal-primary" />
      <Heading2 as="h3" size={1}>
        Loading Identity Preview
      </Heading2>
    </div>
  );
}
